
/* ============================================================================
FILE: po-katupirsia9-annee-posoennoiale-texts-fr-en-es-20260326.js
MODE: protected trilingual with FR / EN / ES buttons + lexicon locking + audio
API:  window.PoKatupirsia9AnneePosoennoialeTextsFR_EN_ES_20260326
ROOT: .po-axis-section[data-po-axis='annee_posoennoiale']
============================================================================ */

(function(){
  "use strict";

  if (window.__PO_KATUPIRSIA9_ANNEE_POSOENNOIALE_TEXTS_20260326__) return;
  window.__PO_KATUPIRSIA9_ANNEE_POSOENNOIALE_TEXTS_20260326__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = ".po-axis-section[data-po-axis='annee_posoennoiale']";

  var __PO_PROTECT_CACHE__ = { key:"", re:null };

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g,"-");
    if (s === "fr" || s.indexOf("fr") === 0) return "fr";
    if (s === "en" || s.indexOf("en") === 0) return "en";
    if (s === "es" || s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "es";
    return "fr";
  }

  function getBrowserLang(){
    var dl = document && document.documentElement ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    if (typeof navigator !== "undefined"){
      if (navigator.languages && navigator.languages.length) return normLang(navigator.languages[0] || "fr");
      if (navigator.language) return normLang(navigator.language || "fr");
    }
    return "fr";
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return v ? normLang(v) : "";
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(_e){}
    try{ document.documentElement.setAttribute("lang", l); }catch(__e){}
    return l;
  }

  function getLang(){
    var s = readStoredLang();
    if (s) return s;
    var dl = (document && document.documentElement) ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    return "fr";
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}
    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(_e){}
    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{
      if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]);
    }catch(e){}
    return "";
  }

  function pickDefShort(entry, lang){
    if (!entry) return "";
    var ks = "definition_short_" + lang;
    var k = "definition_" + lang;
    try{
      if (entry[ks]) return clampStr(entry[ks]);
      if (entry[k]) return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].short) return clampStr(entry.defs[lang].short);
    }catch(e){}
    return "";
  }

  function pickDefLong(entry, lang){
    if (!entry) return "";
    var kl = "definition_long_" + lang;
    var k = "definition_" + lang;
    try{
      if (entry[kl]) return clampStr(entry[kl]);
      if (entry[k]) return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].long) return clampStr(entry.defs[lang].long);
    }catch(e){}
    return "";
  }

  function pickArray(entry, lang, base){
    if (!entry) return [];
    var k = base + "_" + lang;
    try{
      var v = entry[k];
      if (Array.isArray(v)) return v;
    }catch(e){}
    return [];
  }

  function pickAny(entry, key, fallback){
    try{
      if (entry && entry[key] != null) return entry[key];
    }catch(e){}
    return fallback;
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var k = String(v || "");
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, "’"), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, "’"), seen);

    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    return [
      "Année posœnnoïale",
      "AP",
      "AP 12825",
      "3–6–9",
      "3-6-9",
      "Δτ",
      "Numéris",
      "Humanus",
      "Souffle d’Or",
      "Souffle d'or",
      "Isqun",
      "Threnisqun",
      "Sceau d’Équiphase",
      "Épagomènes",
      "Àṣẹxel’Or",
      "Âṣẹxel’Or",
      "Grand Cataclysme",
      "Année 9",
      "Katûpirsia 9",
      "Posœnnoïsme",
      "Posœnnoïa"
    ];
  }

  function buildProtectRegexFromSimplified(){
    var base = getSimplifiedLexiqueFRList();
    var terms = [];
    var seen = Object.create(null);

    for (var i=0;i<base.length;i++){
      var vars = buildVariants(base[i]);
      for (var j=0;j<vars.length;j++) uniqPush(terms, vars[j], seen);
    }

    terms.sort(function(a,b){ return b.length - a.length; });

    var parts = [];
    for (var k=0;k<terms.length;k++) parts.push(escapeRegExp(terms[k]));
    if (!parts.length) return null;

    try{
      return new RegExp("(" + parts.join("|") + ")", "g");
    }catch(e){
      return null;
    }
  }

  function ensureProtectEngineReady(){
    var key = "fallback";
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        key = "meta:" + window.PO_LEXICON_META.lexique_simplifie_fr.length;
      }else if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        key = "meta2:" + window.PO_LEXICON.meta.lexique_simplifie_fr.length;
      }
    }catch(e){ key = "fallback"; }

    if (__PO_PROTECT_CACHE__.key === key && __PO_PROTECT_CACHE__.re) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectRegexFromSimplified();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute("translate");
    if (tr && String(tr).toLowerCase() === "no") return true;
    var cls = el.className || "";
    if (typeof cls === "string"){
      if (cls.indexOf("notranslate") !== -1) return true;
      if (cls.indexOf("po-lex-protect") !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch);
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;

    var txt = textNode.nodeValue;
    if (!txt) return;

    re.lastIndex = 0;
    if (!re.test(txt)) return;
    re.lastIndex = 0;

    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;

    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];
      var end = start + match.length;

      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));

      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : "";
      if (chPrev && isWordLikeChar(chPrev)) frag.appendChild(doc.createTextNode(" "));

      var span = doc.createElement("span");
      span.setAttribute("translate", "no");
      span.className = "po-lex-protect notranslate";
      span.textContent = match;
      frag.appendChild(span);

      var chNext = (end < txt.length) ? txt.charAt(end) : "";
      if (chNext && isWordLikeChar(chNext)) frag.appendChild(doc.createTextNode(" "));

      last = end;
      if (match.length === 0) break;
    }

    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsInElement(el){
    if (!el || !el.querySelectorAll) return;
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return;

    var walker;
    try{
      walker = document.createTreeWalker(
        el,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            var p = n.parentNode;
            var pn = p && p.nodeName ? p.nodeName : "";
            if (pn === "SCRIPT" || pn === "STYLE") return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return; }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
  }

  function lockSlotNode(root, slot){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    if (!el.classList.contains("notranslate")) el.classList.add("notranslate");
    el.setAttribute("translate", "no");
  }

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = clampStr(txt);
    protectKeywordsInElement(el);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = clampStr(html);
    protectKeywordsInElement(el);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    var s = clampStr(src);
    var a = clampStr(alt);
    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt", ""); }catch(_e){}
      try{ el.style.display = "none"; }catch(__e){}
      return;
    }
    el.setAttribute("src", s);
    el.setAttribute("alt", a);
    try{ el.style.display = ""; }catch(e){}
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = "";
    (items || []).forEach(function(item){
      var li = document.createElement("li");
      li.innerHTML = clampStr(item);
      el.appendChild(li);
    });
    protectKeywordsInElement(el);
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    host.innerHTML = "";
    (blocks || []).forEach(function(b){
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";
      var h = document.createElement("div");
      h.className = "po-axis-wb__h";
      h.textContent = clampStr((b || {}).head || "");
      var t = document.createElement("div");
      t.className = "po-axis-wb__t";
      t.innerHTML = clampStr((b || {}).text || "");
      wrap.appendChild(h);
      wrap.appendChild(t);
      host.appendChild(wrap);
    });
    protectKeywordsInElement(host);
  }

  var CONTENT = {
    fr: {
      title: "Année posœnnoïale",
      kicker: "Extrait du <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Organisation des cycles, enveloppe temporelle et respiration du vrai temps)",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      chip_urls: [
        "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Annee_Posoenoiale_copie.png?v=1772925681",
        "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Annee_Posoennoial_fonctionnel.png?v=1773267941"
      ],
      def_short: "Schème K9 d’organisation des cycles, réglé par la dynamique 3–6–9.",
      def_long: "<p><span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> — <span class=\"notranslate\" translate=\"no\">AP / AP 12825</span> — est définie dans le lexique comme le schème K9 d’organisation des cycles, réglé par la dynamique <span class=\"notranslate\" translate=\"no\">3–6–9</span>. Elle organise le temps en cycles lisibles, tenables et réajustables, afin que pratiques et créations se calent sur une cohérence interne.</p><p>Le manuscrit la déploie comme une enveloppe temporelle : une membrane englobante qui ne se limite pas à régler les cycles solaires et lunaires, mais intègre la dynamique vibratoire de l’espace-temps. Là où le calendrier grégorien administre la durée, <span class=\"notranslate\" translate=\"no\">AP</span> distribue la vibration ; l’excédent n’y est pas une anomalie à corriger, mais une énergie à redistribuer.</p><p>Cette redistribution est régulée par <span class=\"notranslate\" translate=\"no\">Isqun</span> et par le <span class=\"notranslate\" translate=\"no\">Sceau d’Équiphase</span>, qui recueillent l’excédent <span class=\"notranslate\" translate=\"no\">Δτ</span>, le désintègrent et le réinjectent dans la trame du temps vécu. Ainsi, le temps excédentaire devient souffle, l’espace diffus se condense en rythme, et la durée s’ouvre comme passage.</p><p>Dans sa portée cosmologique, l’<span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> prend pour origine le <span class=\"notranslate\" translate=\"no\">Grand Cataclysme</span> et condense aujourd’hui la désignation <span class=\"notranslate\" translate=\"no\">AP 12825</span>. Le point d’ancrage retenu se situe autour de <span class=\"notranslate\" translate=\"no\">–10 800</span> avant l’ère grégorienne ; dans cette logique, <span class=\"notranslate\" translate=\"no\">AP 00001</span> commence immédiatement après ce seuil, et l’écart entre <span class=\"notranslate\" translate=\"no\">–10 800</span> et <span class=\"notranslate\" translate=\"no\">2025</span> donne environ <span class=\"notranslate\" translate=\"no\">12 825</span> années solaires.</p><p>Le calcul n’est pourtant pas seulement linéaire : il reçoit aussi une lecture vibratoire, puisque <span class=\"notranslate\" translate=\"no\">1+2+8+2+5 = 18</span>, puis <span class=\"notranslate\" translate=\"no\">1+8 = 9</span>, d’où la correspondance avec une <span class=\"notranslate\" translate=\"no\">Année 9</span>. L’<span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> se lit ainsi comme spirale complète, respiration universelle, médiation entre humain et cosmos, et comme grille de repérage permettant de tenir, relancer ou traverser un cycle avec justesse.</p>",
      h_features: "Dynamiques opératives",
      h_questions: "Applications / repères",
      hint_fold: "déplier",
      h_family: "Liens systémiques",
      h_wordbuild: "Construction du terme",
      features: [
        "Schème K9 du temps : l’Année posœnnoïale organise jours, décades, saisons et épagomènes selon <span class=\"notranslate\" translate=\"no\">3–6–9</span>.",
        "Architecture de respiration : elle rend le temps lisible, tenable et réajustable plutôt qu’arbitraire.",
        "Enveloppe temporelle : elle distribue la vibration et transforme l’excédent en passage opératif.",
        "Médiation cosmique : elle relie l’humain, le rythme du monde et la mémoire longue des cycles.",
        "Grille de situation : <span class=\"notranslate\" translate=\"no\">AP</span> permet de lire un régime, un seuil et l’ajustement minimal qui rend la traversée plus juste."
      ],
      questions: [
        "Où suis-je dans le cycle, et quel régime domine ici : tenir, relancer ou traverser ?",
        "Quel seuil est actif, et quel réglage minimal le rend praticable ?",
        "Le temps vécu est-il subi comme calendrier, ou habité comme structure respirante ?",
        "Quel lien se dessine ici entre <span class=\"notranslate\" translate=\"no\">3–6–9</span>, <span class=\"notranslate\" translate=\"no\">Δτ</span>, <span class=\"notranslate\" translate=\"no\">Numéris</span> et <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> ?"
      ],
      example_box: "<div><strong>Ex.</strong> Situer une œuvre, une pratique ou une décision dans <span class=\"notranslate\" translate=\"no\">AP</span> revient à se demander où l’on se trouve dans le cycle, quel seuil agit, et quel micro-ajustement rend la traversée plus tenable.</div>",
      family_1: "<p><strong>Liens internes :</strong> <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> est contenue dans <span class=\"notranslate\" translate=\"no\">Àṣẹxel’Or</span> et se relie directement à la triade <span class=\"notranslate\" translate=\"no\">3–6–9</span>, à <span class=\"notranslate\" translate=\"no\">Δτ</span>, à <span class=\"notranslate\" translate=\"no\">Numéris</span>, à <span class=\"notranslate\" translate=\"no\">Humanus</span> et à <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span>.</p>",
      family_2: "<p><strong>Fonction systémique :</strong> comme schème temporel, <span class=\"notranslate\" translate=\"no\">AP</span> fournit une grille de repérage et de réglage des passages ; comme enveloppe cosmologique, elle redistribue l’excédent par <span class=\"notranslate\" translate=\"no\">Isqun</span> et le <span class=\"notranslate\" translate=\"no\">Sceau d’Équiphase</span>, jusqu’à faire de la durée une respiration opérative.</p>",
      word_blocks: [
        { head: "1) Année", text: "Cycle long, architecture du temps, retour structuré des seuils, des intensités et des passages." },
        { head: "2) posœnnoïale", text: "Dans le corpus, le terme désigne un régime de temps habitable : respiré, redistribué, orienté par la dynamique <span class=\"notranslate\" translate=\"no\">3–6–9</span>." },
        { head: "3) AP", text: "Le sigle condense une grille opérative : situer un régime, lire un seuil, régler un passage, activer un ajustement minimal." }
      ],
      word_notes: [
        "Traductions attestées dans le lexique : Posœnnoïal Year (AP) / Año posœnnoïal (AP) ; non affichées sur le site pour préserver l’élément canonique.",
        "Deux idéogrammes attestés : conceptuel et fonctionnel.",
        "Fonction : donner une cohérence de cycle et rendre le temps habitable, transmissible et activable.",
        "Repère de datation : origine ancrée autour du Grand Cataclysme, calcul linéaire jusqu’à AP 12825, puis réduction vibratoire vers l’Année 9."
      ],
      cta_translate: "Proposer une traduction du concept"
    },
    en: {
      title: "Année posœnnoïale",
      kicker: "Excerpt from <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Organization of cycles, temporal envelope and respiration of true time)",
      h_def: "Operative definition",
      chips: ["Conceptual ideogram", "Functional ideogram"],
      chip_urls: [
        "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Annee_Posoenoiale_copie.png?v=1772925681",
        "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Annee_Posoennoial_fonctionnel.png?v=1773267941"
      ],
      def_short: "K9 scheme for organizing cycles, regulated by the 3–6–9 dynamic.",
      def_long: "<p><span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> — <span class=\"notranslate\" translate=\"no\">AP / AP 12825</span> — is defined in the lexicon as the K9 scheme for organizing cycles, regulated by the <span class=\"notranslate\" translate=\"no\">3–6–9</span> dynamic. It organizes time into cycles that can be read, held and readjusted so that practices and creations align with an internal coherence.</p><p>The manuscript unfolds it as a temporal envelope: an encompassing membrane that does not merely regulate solar and lunar cycles, but integrates the vibratory dynamic of space-time. Where the Gregorian calendar administers duration, <span class=\"notranslate\" translate=\"no\">AP</span> distributes vibration; the excess is not an anomaly to correct, but an energy to redistribute.</p><p>This redistribution is regulated by <span class=\"notranslate\" translate=\"no\">Isqun</span> and by the <span class=\"notranslate\" translate=\"no\">Sceau d’Équiphase</span>, which gather the excess <span class=\"notranslate\" translate=\"no\">Δτ</span>, disintegrate it and reinject it into the fabric of lived time. Thus, surplus time becomes breath, diffuse space condenses into rhythm and duration opens as passage.</p><p>In its cosmological reach, <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> takes the <span class=\"notranslate\" translate=\"no\">Grand Cataclysme</span> as its origin and today condenses the designation <span class=\"notranslate\" translate=\"no\">AP 12825</span>. The chosen anchoring point lies around <span class=\"notranslate\" translate=\"no\">–10 800</span> before the Gregorian era; in that logic, <span class=\"notranslate\" translate=\"no\">AP 00001</span> begins immediately after that threshold, and the gap between <span class=\"notranslate\" translate=\"no\">–10 800</span> and <span class=\"notranslate\" translate=\"no\">2025</span> yields roughly <span class=\"notranslate\" translate=\"no\">12 825</span> solar years.</p><p>The calculation is not merely linear, however: it also receives a vibratory reading, since <span class=\"notranslate\" translate=\"no\">1+2+8+2+5 = 18</span>, then <span class=\"notranslate\" translate=\"no\">1+8 = 9</span>, hence the correspondence with an <span class=\"notranslate\" translate=\"no\">Année 9</span>. <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> is thus read as a complete spiral, a universal respiration, a mediation between human and cosmos, and as a grid of orientation that helps one hold, relaunch or cross a cycle with accuracy.</p>",
      h_features: "Operative dynamics",
      h_questions: "Applications / markers",
      hint_fold: "expand",
      h_family: "Systemic links",
      h_wordbuild: "Term construction",
      features: [
        "K9 time scheme: <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> organizes days, decades, seasons and epagomenal days according to <span class=\"notranslate\" translate=\"no\">3–6–9</span>.",
        "Architecture of respiration: it makes time readable, sustainable and readjustable rather than arbitrary.",
        "Temporal envelope: it distributes vibration and transforms excess into operative passage.",
        "Cosmic mediation: it links the human being, the rhythm of the world and the long memory of cycles.",
        "Grid of situation: <span class=\"notranslate\" translate=\"no\">AP</span> makes it possible to read a regime, a threshold and the minimal adjustment that makes the traversal more accurate."
      ],
      questions: [
        "Where am I in the cycle, and which regime dominates here: hold, relaunch or traverse?",
        "Which threshold is active, and what minimal adjustment makes it workable?",
        "Is lived time endured as a calendar, or inhabited as a breathing structure?",
        "What link appears here between <span class=\"notranslate\" translate=\"no\">3–6–9</span>, <span class=\"notranslate\" translate=\"no\">Δτ</span>, <span class=\"notranslate\" translate=\"no\">Numéris</span> and <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span>?"
      ],
      example_box: "<div><strong>Ex.</strong> To situate an artwork, a practice or a decision in <span class=\"notranslate\" translate=\"no\">AP</span> is to ask where one stands in the cycle, which threshold is active and which micro-adjustment makes the crossing more sustainable.</div>",
      family_1: "<p><strong>Internal links:</strong> <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> is contained within <span class=\"notranslate\" translate=\"no\">Àṣẹxel’Or</span> and links directly with the triad <span class=\"notranslate\" translate=\"no\">3–6–9</span>, with <span class=\"notranslate\" translate=\"no\">Δτ</span>, with <span class=\"notranslate\" translate=\"no\">Numéris</span>, with <span class=\"notranslate\" translate=\"no\">Humanus</span> and with <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span>.</p>",
      family_2: "<p><strong>Systemic function:</strong> as a temporal scheme, <span class=\"notranslate\" translate=\"no\">AP</span> provides a grid for orienting and tuning passages; as a cosmological envelope, it redistributes excess through <span class=\"notranslate\" translate=\"no\">Isqun</span> and the <span class=\"notranslate\" translate=\"no\">Sceau d’Équiphase</span>, turning duration into operative respiration.</p>",
      word_blocks: [
        { head: "1) Year", text: "Long cycle, architecture of time, structured return of thresholds, intensities and passages." },
        { head: "2) posœnnoïale", text: "In the corpus, the term designates a regime of time that is inhabitable: breathed, redistributed and oriented by the dynamic <span class=\"notranslate\" translate=\"no\">3–6–9</span>." },
        { head: "3) AP", text: "The siglum condenses an operative grid: locate a regime, read a threshold, tune a passage and apply a minimal adjustment." }
      ],
      word_notes: [
        "Translations attested in the lexicon: Posœnnoïal Year (AP) / Año posœnnoïal (AP); not displayed on the site in order to preserve the canonical element.",
        "Two attested ideograms: conceptual and functional.",
        "Function: to provide cycle coherence and make time inhabitable, transmissible and activable.",
        "Dating marker: origin anchored around the Grand Cataclysm, linear calculation up to AP 12825, then vibratory reduction toward Année 9."
      ],
      cta_translate: "Suggest a translation of the concept"
    },
    es: {
      title: "Année posœnnoïale",
      kicker: "Extracto de <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Organización de ciclos, envolvente temporal y respiración del tiempo verdadero)",
      h_def: "Definición operativa",
      chips: ["Ideograma conceptual", "Ideograma funcional"],
      chip_urls: [
        "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Annee_Posoenoiale_copie.png?v=1772925681",
        "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Annee_Posoennoial_fonctionnel.png?v=1773267941"
      ],
      def_short: "Esquema K9 de organización de ciclos, regulado por la dinámica 3–6–9.",
      def_long: "<p><span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> — <span class=\"notranslate\" translate=\"no\">AP / AP 12825</span> — se define en el léxico como el esquema K9 de organización de ciclos, regulado por la dinámica <span class=\"notranslate\" translate=\"no\">3–6–9</span>. Organiza el tiempo en ciclos legibles, sostenibles y reajustables, para que prácticas y creaciones se calibren sobre una coherencia interna.</p><p>El manuscrito la despliega como una envolvente temporal: una membrana englobante que no se limita a regular los ciclos solares y lunares, sino que integra la dinámica vibratoria del espacio-tiempo. Allí donde el calendario gregoriano administra la duración, <span class=\"notranslate\" translate=\"no\">AP</span> distribuye la vibración; el exceso no es una anomalía que corregir, sino una energía que redistribuir.</p><p>Esta redistribución está regulada por <span class=\"notranslate\" translate=\"no\">Isqun</span> y por el <span class=\"notranslate\" translate=\"no\">Sceau d’Équiphase</span>, que recogen el excedente <span class=\"notranslate\" translate=\"no\">Δτ</span>, lo desintegran y lo reinyectan en la trama del tiempo vivido. Así, el tiempo excedentario se vuelve soplo, el espacio difuso se condensa en ritmo y la duración se abre como paso.</p><p>En su alcance cosmológico, <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> toma el <span class=\"notranslate\" translate=\"no\">Grand Cataclysme</span> como origen y hoy condensa la designación <span class=\"notranslate\" translate=\"no\">AP 12825</span>. El punto de anclaje elegido se sitúa alrededor de <span class=\"notranslate\" translate=\"no\">–10 800</span> antes de la era gregoriana; en esa lógica, <span class=\"notranslate\" translate=\"no\">AP 00001</span> comienza inmediatamente después de ese umbral, y la diferencia entre <span class=\"notranslate\" translate=\"no\">–10 800</span> y <span class=\"notranslate\" translate=\"no\">2025</span> da aproximadamente <span class=\"notranslate\" translate=\"no\">12 825</span> años solares.</p><p>El cálculo, sin embargo, no es solo lineal: recibe también una lectura vibratoria, puesto que <span class=\"notranslate\" translate=\"no\">1+2+8+2+5 = 18</span>, luego <span class=\"notranslate\" translate=\"no\">1+8 = 9</span>, de ahí la correspondencia con una <span class=\"notranslate\" translate=\"no\">Année 9</span>. La <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> se lee así como espiral completa, respiración universal, mediación entre humano y cosmos, y como rejilla de orientación que permite sostener, relanzar o atravesar un ciclo con justeza.</p>",
      h_features: "Dinámicas operativas",
      h_questions: "Aplicaciones / referencias",
      hint_fold: "desplegar",
      h_family: "Vínculos sistémicos",
      h_wordbuild: "Construcción del término",
      features: [
        "Esquema temporal K9: <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> organiza días, décadas, estaciones y epagómenos según <span class=\"notranslate\" translate=\"no\">3–6–9</span>.",
        "Arquitectura de respiración: vuelve el tiempo legible, sostenible y reajustable en lugar de arbitrario.",
        "Envolvente temporal: distribuye la vibración y transforma el excedente en paso operativo.",
        "Mediación cósmica: enlaza al ser humano, el ritmo del mundo y la memoria larga de los ciclos.",
        "Rejilla de situación: <span class=\"notranslate\" translate=\"no\">AP</span> permite leer un régimen, un umbral y el ajuste mínimo que vuelve más justa la travesía."
      ],
      questions: [
        "¿Dónde estoy en el ciclo y qué régimen domina aquí: sostener, relanzar o atravesar?",
        "¿Qué umbral está activo y qué ajuste mínimo lo vuelve practicable?",
        "¿El tiempo vivido se padece como calendario o se habita como estructura respirante?",
        "¿Qué vínculo aparece aquí entre <span class=\"notranslate\" translate=\"no\">3–6–9</span>, <span class=\"notranslate\" translate=\"no\">Δτ</span>, <span class=\"notranslate\" translate=\"no\">Numéris</span> y <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span>?"
      ],
      example_box: "<div><strong>Ej.</strong> Situar una obra, una práctica o una decisión en <span class=\"notranslate\" translate=\"no\">AP</span> consiste en preguntar dónde se está en el ciclo, qué umbral actúa y qué microajuste vuelve más sostenible la travesía.</div>",
      family_1: "<p><strong>Vínculos internos:</strong> <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> está contenida en <span class=\"notranslate\" translate=\"no\">Àṣẹxel’Or</span> y se enlaza directamente con la tríada <span class=\"notranslate\" translate=\"no\">3–6–9</span>, con <span class=\"notranslate\" translate=\"no\">Δτ</span>, con <span class=\"notranslate\" translate=\"no\">Numéris</span>, con <span class=\"notranslate\" translate=\"no\">Humanus</span> y con <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span>.</p>",
      family_2: "<p><strong>Función sistémica:</strong> como esquema temporal, <span class=\"notranslate\" translate=\"no\">AP</span> proporciona una rejilla de orientación y ajuste de los pasos; como envolvente cosmológica, redistribuye el excedente por medio de <span class=\"notranslate\" translate=\"no\">Isqun</span> y del <span class=\"notranslate\" translate=\"no\">Sceau d’Équiphase</span>, hasta convertir la duración en respiración operativa.</p>",
      word_blocks: [
        { head: "1) Año", text: "Ciclo largo, arquitectura del tiempo, retorno estructurado de umbrales, intensidades y pasos." },
        { head: "2) posœnnoïale", text: "En el corpus, el término designa un régimen de tiempo habitable: respirado, redistribuido y orientado por la dinámica <span class=\"notranslate\" translate=\"no\">3–6–9</span>." },
        { head: "3) AP", text: "La sigla condensa una rejilla operativa: situar un régimen, leer un umbral, ajustar un paso y aplicar un ajuste mínimo." }
      ],
      word_notes: [
        "Traducciones atestiguadas en el léxico: Posœnnoïal Year (AP) / Año posœnnoïal (AP); no se muestran en el sitio para preservar el elemento canónico.",
        "Dos ideogramas atestiguados: conceptual y funcional.",
        "Función: dar una coherencia de ciclo y volver el tiempo habitable, transmisible y activable.",
        "Referencia de datación: origen anclado en torno al Grand Cataclysme, cálculo lineal hasta AP 12825 y luego reducción vibratoria hacia Année 9."
      ],
      cta_translate: "Proponer una traducción del concepto"
    }
  };

  /* ============================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ============================================================================ */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: ""
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){
    var L = normLang(lang);
    return AUDIO_UI[L] || AUDIO_UI.fr;
  }

  function getAudioRoots(){
    return getTargetBlocks();
  }

  function getDetailBlocks(root){
    return root ? Array.prototype.slice.call(root.querySelectorAll(".po-lex-details") || []) : [];
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-axis-audio-styles-annee-posoennoiale")) return;
    var style = document.createElement("style");
    style.id = "po-axis-audio-styles-annee-posoennoiale";
    style.textContent =
      ".po-axis-audio-wrap{display:flex;align-items:center;gap:.6rem;margin:1rem 0 1.15rem 0;}" +
      ".po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid currentColor;background:transparent;color:inherit;padding:.55rem .9rem;border-radius:999px;cursor:pointer;font:inherit;line-height:1.2;transition:opacity .2s ease,transform .2s ease;}" +
      ".po-axis-audio-btn:hover{transform:translateY(-1px);}" +
      ".po-axis-audio-btn[aria-pressed='true']{font-weight:600;}" +
      ".po-lex-summary .po-axis-audio-btn{margin-left:.75rem;vertical-align:middle;}" +
      "@media (max-width:640px){.po-lex-summary .po-axis-audio-btn{display:block;margin:.65rem 0 0 0;}}";
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-role", role === "general" ? "general" : "detail");
    btn.setAttribute("aria-pressed", "false");
    btn.setAttribute("translate", "yes");
    return btn;
  }

  function getTextValue(el){
    if (!el) return "";
    var txt = "";
    try{ txt = el.textContent || el.innerText || ""; }catch(e){ txt = ""; }
    return clampStr(txt).replace(/\s+/g, " ").trim();
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll(".po-axis-audio-wrap, .po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
    }
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join(". ");
  }

  function collectDetailText(detail){
    if (!detail) return "";
    var parts = [];
    var title = detail.querySelector(".po-lex-summary__title");
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);

    var clone = detail.cloneNode(true);
    var summary = clone.querySelector(".po-lex-summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);

    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);

    return parts.join(". ");
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, " ").trim();
    if (!raw) return [];
    var pieces = raw.match(/[^.!?;:]+[.!?;:]?/g) || [raw];
    var out = [];
    var current = "";

    for (var i=0;i<pieces.length;i++){
      var piece = clampStr(pieces[i]).trim();
      if (!piece) continue;
      if (((current ? current + " " : "") + piece).length > 220){
        if (current) out.push(current.trim());
        current = piece;
      }else{
        current = current ? (current + " " + piece) : piece;
      }
    }
    if (current) out.push(current.trim());
    return out;
  }

  function getSpeechLangCode(lang){
    var L = normLang(lang);
    if (L === "en") return "en-US";
    if (L === "es") return "es-ES";
    return "fr-FR";
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var ui = audioUI(lang);
    var generalBtn = root.querySelector(".po-axis-audio-btn[data-po-audio-role='general']");
    if (generalBtn){
      var generalActive = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === "general");
      generalBtn.setAttribute("aria-pressed", generalActive ? "true" : "false");
      generalBtn.textContent = generalActive ? ui.stop : ui.general;
    }

    var detailBtns = root.querySelectorAll(".po-axis-audio-btn[data-po-audio-role='detail']");
    Array.prototype.forEach.call(detailBtns, function(btn){
      var idx = clampStr(btn.getAttribute("data-po-audio-index"));
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === ("detail-" + idx));
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.textContent = active ? ui.stop : ui.block;
    });
  }

  function stopAudio(){
    try{
      if (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)) PO_AUDIO_SYNTH.cancel();
    }catch(e){}

    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";

    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++) refreshAudioLabels(roots[i], getLang());
  }

  function openDetailIfNeeded(detail){
    if (!detail || detail.open) return;
    try{ detail.open = true; }catch(e){}
  }

  function speakChunks(root, lang, chunks, done){
    if (!PO_AUDIO_SYNTH || !chunks.length){
      done();
      return;
    }

    var idx = 0;

    function next(){
      if (idx >= chunks.length){
        done();
        return;
      }

      var utt = new SpeechSynthesisUtterance(chunks[idx]);
      utt.lang = getSpeechLangCode(lang);
      utt.rate = 0.98;
      utt.pitch = 1;

      utt.onend = function(){
        idx++;
        next();
      };

      utt.onerror = function(){
        idx++;
        next();
      };

      try{
        PO_AUDIO_SYNTH.speak(utt);
      }catch(e){
        idx++;
        next();
      }
    }

    next();
  }

  function playUnits(root, startPos){
    if (!root) return;
    var lang = getLang();
    var units = PO_AUDIO_STATE.units;
    if (!units || !units.length) return;

    PO_AUDIO_STATE.root = root;

    function run(pos){
      if (pos >= units.length){
        stopAudio();
        return;
      }

      var unit = units[pos];
      PO_AUDIO_STATE.unitPos = pos;
      PO_AUDIO_STATE.activeKey = unit.key;

      if (unit.detailNode) openDetailIfNeeded(unit.detailNode);
      refreshAudioLabels(root, lang);

      var chunks = splitTextForSpeech(unit.text);
      speakChunks(root, lang, chunks, function(){
        run(pos + 1);
      });
    }

    run(startPos);
  }

  function buildAudioUnits(root){
    var units = [];
    var general = collectGeneralText(root);
    if (general) units.push({ key:"general", text:general, detailNode:null });

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var text = collectDetailText(details[i]);
      if (text) units.push({ key:"detail-" + i, text:text, detailNode:details[i] });
    }
    return units;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (panel){
      var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
      if (!generalWrap){
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap";
        generalWrap.setAttribute("data-po-audio-role", "general");

        var generalBtn = createAudioButton("general");
        generalWrap.appendChild(generalBtn);

        var meta = root.querySelector(".po-axis-meta");
        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetail = panel.querySelector(".po-lex-details");

        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        } else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        } else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        } else {
          panel.appendChild(generalWrap);
        }
      }
    }

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var detail = details[i];
      var summary = detail.querySelector(".po-lex-summary");
      if (!summary) continue;

      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-role='detail']");
      if (!btn){
        btn = createAudioButton("detail");
        summary.appendChild(btn);
      }
      btn.setAttribute("data-po-audio-index", String(i));
    }
  }

  function bindAudioButtons(root){
    if (!root || root.__po_audio_bound) return;
    root.__po_audio_bound = true;

    root.addEventListener("click", function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest(".po-axis-audio-btn") : null;
      if (!btn || !root.contains(btn)) return;

      ev.preventDefault();
      ev.stopPropagation();

      var role = btn.getAttribute("data-po-audio-role");
      var index = btn.getAttribute("data-po-audio-index");
      var key = role === "general" ? "general" : ("detail-" + index);

      if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key){
        stopAudio();
        return;
      }

      stopAudio();
      PO_AUDIO_STATE.units = buildAudioUnits(root);

      var startPos = 0;
      if (role === "detail"){
        for (var i=0;i<PO_AUDIO_STATE.units.length;i++){
          if (PO_AUDIO_STATE.units[i].key === key){
            startPos = i;
            break;
          }
        }
      }

      playUnits(root, startPos);
    });
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  function updateButtons(root, lang){
    var current = normLang(lang);
    var btns = root.querySelectorAll(".po-langbtn");
    Array.prototype.forEach.call(btns, function(btn){
      var btnLang = normLang(btn.getAttribute("data-po-lang") || "fr");
      btn.setAttribute("aria-pressed", btnLang === current ? "true" : "false");
    });
  }

  function setCTA(root, lang){
    var T = CONTENT[normLang(lang)] || CONTENT.fr;
    setSlotText(root, "cta_translate", T.cta_translate);
  }

  function wireButtons(root){
    if (root.__po_lang_bound) return;
    root.__po_lang_bound = true;
    var btns = root.querySelectorAll(".po-langbtn");
    Array.prototype.forEach.call(btns, function(btn){
      btn.addEventListener("click", function(){
        setLang(btn.getAttribute("data-po-lang") || "fr");
      });
    });
  }

  function renderRoot(root, lang){
    var L = normLang(lang);
    var T = CONTENT[L] || CONTENT.fr;

    setSlotText(root, "title", T.title);
    setSlotHTML(root, "kicker", T.kicker);
    setSlotImgSrc(root, "title_img", T.chip_urls[0], T.title);

    setSlotText(root, "h_def", T.h_def);

    setSlotText(root, "chip_1", T.chips[0]);
    setSlotText(root, "chip_2", T.chips[1]);
    setSlotImgSrc(root, "chip_1_img", T.chip_urls[0], T.chips[0]);
    setSlotImgSrc(root, "chip_2_img", T.chip_urls[1], T.chips[1]);

    setSlotHTML(root, "def_short", T.def_short);
    setSlotHTML(root, "def_long", T.def_long);

    setSlotText(root, "h_features", T.h_features);
    setSlotText(root, "h_questions", T.h_questions);
    setSlotText(root, "hint_fold", T.hint_fold);
    setSlotText(root, "hint_fold2", T.hint_fold);
    setSlotText(root, "h_family", T.h_family);
    setSlotText(root, "hint_fold3", T.hint_fold);
    setSlotText(root, "h_wordbuild", T.h_wordbuild);
    setSlotText(root, "hint_fold4", T.hint_fold);

    renderListInto(root, "features", T.features);
    renderListInto(root, "questions", T.questions);
    setSlotHTML(root, "example_box", T.example_box);
    setSlotHTML(root, "family_1", T.family_1);
    setSlotHTML(root, "family_2", T.family_2);
    renderWordBlocks(root, "wordbuild_blocks", T.word_blocks);
    renderListInto(root, "wordbuild_notes", T.word_notes);

    setCTA(root, L);
    updateButtons(root, L);
    wireButtons(root);
    protectKeywordsInElement(root);
  }

  function getTargetBlocks(){
    return document.querySelectorAll(ROOT_SEL);
  }

  function applyLangEverywhere(lang){
    var L = normLang(lang);
    storeLang(L);
    var blocks = getTargetBlocks();
    for (var i=0;i<blocks.length;i++) renderRoot(blocks[i], L);
    initAudioEverywhere(L);
  }

  function setLang(lang){
    var l = storeLang(lang);
    applyLangEverywhere(l);
    notifyLocaleChanged();
    return l;
  }

  function init(){
    applyLangEverywhere(getLang());
    try{
      window.addEventListener("po:lexicon-ready", function(){
        __PO_PROTECT_CACHE__.key = "";
        __PO_PROTECT_CACHE__.re = null;
        applyLangEverywhere(getLang());
      });
    }catch(e){}
  }

  window.PoKatupirsia9AnneePosoennoialeTextsFR_EN_ES_20260326 = {
    init: init,
    setLang: setLang,
    getLang: getLang,
    normLang: normLang,
    stopAudio: stopAudio,
    getLexiconEntry: getLexiconEntry,
    pickTerm: pickTerm,
    pickDefShort: pickDefShort,
    pickDefLong: pickDefLong,
    pickArray: pickArray,
    pickAny: pickAny
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  if (typeof window.GoodyTwinLang.getLang !== "function") window.GoodyTwinLang.getLang = getLang;
  if (typeof window.GoodyTwinLang.setLang !== "function") window.GoodyTwinLang.setLang = setLang;
  if (typeof window.GoodyTwinLang.init !== "function") window.GoodyTwinLang.init = init;

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
